import script from "./GoToSpringboardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GoToSpringboardModal.vue?vue&type=script&setup=true&lang=js"

import "./GoToSpringboardModal.vue?vue&type=style&index=0&id=38c220dd&scoped=true&lang=scss"
script.__scopeId = "data-v-38c220dd"

export default script